import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function Refund() {
  return (
    <LegalLayout title="Refund Policy" updated="February 6, 2026">
      <p>
        We want every Foldora experience to be worth it. If something goes wrong, here&rsquo;s what to expect.
      </p>
      <h2>1. Service issues</h2>
      <p>
        If your laundry is not returned within our stated window, or if the quality falls short (e.g., stains not properly
        addressed after we accepted the order), contact us within <strong>48 hours of delivery</strong>. We&rsquo;ll re-wash the
        affected items for free or refund the affected portion of the order.
      </p>
      <h2>2. Cancellations</h2>
      <ul>
        <li>Cancelled more than 12 hours before pickup: <strong>full refund</strong> (no fee).</li>
        <li>Cancelled less than 12 hours before pickup: <strong>$10 fee</strong>, remainder refunded.</li>
        <li>Missed pickup (nobody at door for two attempts): non-refundable $10 service fee.</li>
      </ul>
      <h2>3. Method &amp; timing</h2>
      <p>
        Card/PayPal refunds are issued to the original payment method and typically appear within 5–10 business days.
        Referral credits used on an order are automatically restored to your account.
      </p>
      <h2>4. Non-refundable</h2>
      <ul>
        <li>Custom / rush requests once processing has started.</li>
        <li>Items lost or damaged beyond the limits of our Damage Policy.</li>
      </ul>
      <h2>5. Contact</h2>
      <p>Email info@foldora.ca with your order ID and photos, and we&rsquo;ll get it sorted within one business day.</p>
    </LegalLayout>
  );
}
